import React from 'react'

interface GradientIconProps {
  icon: React.ReactNode
}

const GradientIcon = ({ icon }: GradientIconProps) => {
  return (
    <div className='rounded-full shadow-md w-fit bg-gradient-to-r from-gray-900 to-gray-600'>
      <div className='flex justify-center items-center p-3 text-white'>{icon}</div>
    </div>
  )
}

export default GradientIcon
